export const OPENING_HOUR_ADD_SUCCESS = 'OPENING_HOUR_ADD_SUCCESS';
export const OPENING_HOUR_UPDATE_SUCCESS = 'OPENING_HOUR_UPDATE_SUCCESS';
export const OPENING_HOUR_DELETE_SUCCESS = 'OPENING_HOUR_DELETE_SUCCESS';